export type Country = { code: string; name: string; flag: string };

/** Vanligaste först i formulären – finns även med i A–Ö-listan. */
export const TOP_COUNTRY_CODES = ["SE", "ES", "NO", "DK", "FI"];

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
  { code: "AL", name: "Albanien", flag: "🇦🇱" },
  { code: "DZ", name: "Algeriet", flag: "🇩🇿" },
  { code: "AR", name: "Argentina", flag: "🇦🇷" },
  { code: "AU", name: "Australien", flag: "🇦🇺" },
  { code: "BE", name: "Belgien", flag: "🇧🇪" },
  { code: "BA", name: "Bosnien och Hercegovina", flag: "🇧🇦" },
  { code: "BR", name: "Brasilien", flag: "🇧🇷" },
  { code: "BG", name: "Bulgarien", flag: "🇧🇬" },
  { code: "CA", name: "Kanada", flag: "🇨🇦" },
  { code: "CL", name: "Chile", flag: "🇨🇱" },
  { code: "CO", name: "Colombia", flag: "🇨🇴" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷" },
  { code: "CY", name: "Cypern", flag: "🇨🇾" },
  { code: "DK", name: "Danmark", flag: "🇩🇰" },
  { code: "EG", name: "Egypten", flag: "🇪🇬" },
  { code: "EE", name: "Estland", flag: "🇪🇪" },
  { code: "FI", name: "Finland", flag: "🇫🇮" },
  { code: "FR", name: "Frankrike", flag: "🇫🇷" },
  { code: "GR", name: "Grekland", flag: "🇬🇷" },
  { code: "IN", name: "Indien", flag: "🇮🇳" },
  { code: "ID", name: "Indonesien", flag: "🇮🇩" },
  { code: "IQ", name: "Irak", flag: "🇮🇶" },
  { code: "IR", name: "Iran", flag: "🇮🇷" },
  { code: "IE", name: "Irland", flag: "🇮🇪" },
  { code: "IS", name: "Island", flag: "🇮🇸" },
  { code: "IL", name: "Israel", flag: "🇮🇱" },
  { code: "IT", name: "Italien", flag: "🇮🇹" },
  { code: "JP", name: "Japan", flag: "🇯🇵" },
  { code: "CN", name: "Kina", flag: "🇨🇳" },
  { code: "HR", name: "Kroatien", flag: "🇭🇷" },
  { code: "LV", name: "Lettland", flag: "🇱🇻" },
  { code: "LB", name: "Libanon", flag: "🇱🇧" },
  { code: "LT", name: "Litauen", flag: "🇱🇹" },
  { code: "LU", name: "Luxemburg", flag: "🇱🇺" },
  { code: "MA", name: "Marocko", flag: "🇲🇦" },
  { code: "MX", name: "Mexiko", flag: "🇲🇽" },
  { code: "MD", name: "Moldavien", flag: "🇲🇩" },
  { code: "NL", name: "Nederländerna", flag: "🇳🇱" },
  { code: "NO", name: "Norge", flag: "🇳🇴" },
  { code: "NZ", name: "Nya Zeeland", flag: "🇳🇿" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰" },
  { code: "PL", name: "Polen", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "RO", name: "Rumänien", flag: "🇷🇴" },
  { code: "RU", name: "Ryssland", flag: "🇷🇺" },
  { code: "CH", name: "Schweiz", flag: "🇨🇭" },
  { code: "RS", name: "Serbien", flag: "🇷🇸" },
  { code: "SK", name: "Slovakien", flag: "🇸🇰" },
  { code: "SI", name: "Slovenien", flag: "🇸🇮" },
  { code: "ES", name: "Spanien", flag: "🇪🇸" },
  { code: "GB", name: "Storbritannien", flag: "🇬🇧" },
  { code: "SD", name: "Sudan", flag: "🇸🇩" },
  { code: "SE", name: "Sverige", flag: "🇸🇪" },
  { code: "ZA", name: "Sydafrika", flag: "🇿🇦" },
  { code: "KR", name: "Sydkorea", flag: "🇰🇷" },
  { code: "SY", name: "Syrien", flag: "🇸🇾" },
  { code: "CZ", name: "Tjeckien", flag: "🇨🇿" },
  { code: "TR", name: "Turkiet", flag: "🇹🇷" },
  { code: "DE", name: "Tyskland", flag: "🇩🇪" },
  { code: "UA", name: "Ukraina", flag: "🇺🇦" },
  { code: "HU", name: "Ungern", flag: "🇭🇺" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾" },
  { code: "US", name: "USA", flag: "🇺🇸" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳" },
  { code: "AT", name: "Österrike", flag: "🇦🇹" },
];

export type Option = {
  value: string;
  label: string;
  group?: string;
  /** ISO-kod för rund flaggikon. */
  flagCode?: string;
  flagEmoji?: string;
};

function toOption(c: Country, group?: string): Option {
  return {
    value: c.name,
    label: c.name,
    flagCode: c.code,
    flagEmoji: c.flag,
    ...(group ? { group } : {}),
  };
}


/** Vanligaste överst + hela listan i bokstavsordning. */
export function countryOptions(topCodes: string[] = TOP_COUNTRY_CODES): Option[] {
  const top = topCodes
    .map((code) => COUNTRIES.find((c) => c.code === code))
    .filter((c): c is Country => Boolean(c))
    .map((c) => toOption(c, "Vanligast"));
  const rest = [...COUNTRIES]
    .sort((a, b) => a.name.localeCompare(b.name, "sv"))
    .map((c) => toOption(c, "Alla länder A–Ö"));
  return [...top, ...rest];
}

/** Engelska/spanska/svenska adjektiv och namn → kanoniskt svenskt landsnamn. */
const COUNTRY_ALIASES: Record<string, string> = {
  spain: "Spanien",
  spanien: "Spanien",
  españa: "Spanien",
  spansk: "Spanien",
  spanska: "Spanien",
  spanish: "Spanien",
  español: "Spanien",
  española: "Spanien",
  sweden: "Sverige",
  sverige: "Sverige",
  suecia: "Sverige",
  svensk: "Sverige",
  svenska: "Sverige",
  swedish: "Sverige",
  sueco: "Sverige",
  sueca: "Sverige",
  norway: "Norge",
  norge: "Norge",
  noruega: "Norge",
  norsk: "Norge",
  norska: "Norge",
  norwegian: "Norge",
  noruego: "Norge",
  denmark: "Danmark",
  danmark: "Danmark",
  dinamarca: "Danmark",
  dansk: "Danmark",
  danska: "Danmark",
  danish: "Danmark",
  finland: "Finland",
  finlandia: "Finland",
  finsk: "Finland",
  finska: "Finland",
  finnish: "Finland",
  "united kingdom": "Storbritannien",
  uk: "Storbritannien",
  "great britain": "Storbritannien",
  england: "Storbritannien",
  storbritannien: "Storbritannien",
  brittisk: "Storbritannien",
  brittiska: "Storbritannien",
  british: "Storbritannien",
  germany: "Tyskland",
  tyskland: "Tyskland",
  alemania: "Tyskland",
  tysk: "Tyskland",
  tyska: "Tyskland",
  german: "Tyskland",
  france: "Frankrike",
  frankrike: "Frankrike",
  francia: "Frankrike",
  fransk: "Frankrike",
  franska: "Frankrike",
  french: "Frankrike",
  usa: "USA",
  "united states": "USA",
  "united states of america": "USA",
  amerikansk: "USA",
  amerikanska: "USA",
  american: "USA",
  netherlands: "Nederländerna",
  holland: "Nederländerna",
  nederländerna: "Nederländerna",
  dutch: "Nederländerna",
  poland: "Polen",
  polen: "Polen",
  polonia: "Polen",
  polsk: "Polen",
  polska: "Polen",
  polish: "Polen",
};

/**
 * Översätter fritext (t.ex. "Spain", "sueca", "svensk") till det kanoniska
 * svenska landsnamnet i COUNTRIES. Okända värden blir "" så användaren får
 * välja själv i stället för att ett ogiltigt värde fastnar i selecten.
 */
export function normalizeCountryName(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return "";
  const exact = COUNTRIES.find((c) => c.name.toLowerCase() === trimmed.toLowerCase());
  if (exact) return exact.name;
  const alias = COUNTRY_ALIASES[trimmed.toLowerCase()];
  return alias ?? "";
}

/** Spanska provinser, Málaga överst. */
export const SPANISH_PROVINCES = [
  "Málaga",
  "Cádiz",
  "Sevilla",
  "Granada",
  "Almería",
  "Córdoba",
  "Huelva",
  "Jaén",
  "Alicante",
  "Barcelona",
  "Madrid",
  "Murcia",
  "Valencia",
  "Baleares",
  "Las Palmas",
  "Santa Cruz de Tenerife",
];

export function provinceOptions(): Option[] {
  const rest = [...SPANISH_PROVINCES].sort((a, b) => a.localeCompare(b, "sv"));
  return [
    { value: "Málaga", label: "Málaga", group: "Vanligast" },
    ...rest.map((p) => ({ value: p, label: p, group: "Alla provinser A–Ö" })),
  ];
}

/** Svenska län – används när bostadslandet är Sverige. */
